/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * チャプター（目次）の1項目。動画の属性（ADR-0016）。
 */
export interface VideoChapter {
  title: string
  time: number
}
